export default __webpack_public_path__ + "static/media/531.b0d5f6cb.jpg";